import { render, staticRenderFns } from "./breakdowns.vue?vue&type=template&id=c01d5f94&scoped=true"
import script from "./breakdowns.vue?vue&type=script&lang=js"
export * from "./breakdowns.vue?vue&type=script&lang=js"
import style0 from "./breakdowns.vue?vue&type=style&index=0&id=c01d5f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01d5f94",
  null
  
)

export default component.exports